import { render, staticRenderFns } from "./eventInfo.vue?vue&type=template&id=a413f882&scoped=true&"
import script from "./eventInfo.vue?vue&type=script&lang=js&"
export * from "./eventInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a413f882",
  null
  
)

export default component.exports